import { QBOTimelFormData } from './../../../modules/settings/SettingsPage/Components/IntegrationsTab/QBOTimeModal/QBOTimeModal';
import { CardConnectFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/CardConnectModal/CardConnectModal';
import { DiaSparkFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/DiaSparkModal/DiaSparkModal';
import { GHLFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/GHLOverlay/GHLOverlay';
import { IntuitPaymentFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/IntuitPaymentModal/IntuitPaymentModal';
import { KartraFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/KartraOverlay/KartraOverlay';
import { RaveFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/RaveVendorOverlay/RaveVendorOverlay';
import { RingCentralFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/RingCentralModal/RingCentralModal';
import { SalesJetFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/SalesJetModal/SalesJetModal';
import { StripePaymentFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/StripePaymentModal/StripePaymentModal';
import { VendastaFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/VendastaModal/VendastaModal';
import { CompanyId } from '../companies';
import { TaxjarFormData } from './../../../modules/settings/SettingsPage/Components/IntegrationsTab/taxjar/TaxjarOverlay';
import { NmiPaymentFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/NmiPaymentModal/NmiPaymentModal';
import { SurveyMonkeyFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/SurveyMonkey/SurveyMonkeyOverlay';
import { CANAFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/CanaIntegrationModal/CanaIntegrationModal';
import { CustomAddressFormData } from '@business/services/custom_field_service/AddressCustomField';
import {
  ActiveCampaignsFieldFormData,
  ActiveCompaignFormData,
} from '@modules/settings/SettingsPage/Components/IntegrationsTab/ActiveCompaign/ActiveCompaignOverlay';
import { UserId } from '../account';
import { AffindaFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/AffindaModal/AffindaModal';

export type IntegrationId = string;

export enum IntegrationGroup {
  accounting = 'accounting',
  payment = 'payment',
  phone = 'phone',
  marketing = 'marketing',
  orders = 'orders',
  other = 'other',
  tax = 'tax',
}

export enum IntegrationType {
  quickbooks = 'quickbooks',
  stripe = 'stripe',
  ringcentral = 'ringcentral',
  vendasta = 'vendasta',
  diaspark = 'diaspark',
  intuit = 'intuit',
  surveymonkey = 'surveymonkey',
  activecompaign = 'activecompaign',
  cardConnect = 'cardConnect',
  kartra = 'kartra',
  ghl = 'ghl',
  salesjet = 'salesjet',
  ravevendor = 'ravevendor',
  taxjar = 'taxjar',
  raveretailer = 'raveretailer',
  nmi = 'nmi',
  cana = 'cana',
  authorize = 'authorize',
  qbotime = 'qbotime',
  clickup = 'clickup',
  affinda = 'affinda',
}

export interface QuickBooksInfo {
  name: string;
  legalName: string;
  email: string;
  serviceAccountId: string;
  incomeAccountId: string;
  expenseAccountId: string;
  assetAccountId: string;
  discountAccountId: string;
  payableAccountId: string;
  invoiceNameField: string;
  poNameField: string;
  invoiceSalesRep: string;
  invoicePONumber: string;
  isAST?: boolean;
}
export interface IntuitInfo {
  name: string;
  legalName: string;
  email: string;
  cc: boolean;
  ach: boolean;
  ccPaymentMethod: string;
  achPaymentMethod: string;
}

export interface StripeInfo {
  apiKey: string;
  apiVersion: string;
}

export type PaymentIntegrationSettings = IntuitPaymentFormData | StripePaymentFormData | NmiPaymentFormData | CardConnectFormData;
export interface IntegrationResponse {
  id: IntegrationId;
  companyId: CompanyId;
  companyName: string;
  group: IntegrationGroup;
  type: IntegrationType;
  isEnabled: boolean;
  info: QuickBooksInfo | VendastaFormData | IntuitInfo | ClickupInfo;
  settings?:
    | QuickBooksInfo
    | VendastaFormData
    | DiaSparkFormData
    | IntuitPaymentFormData
    | StripePaymentFormData
    | KartraFormData
    | SalesJetFormData
    | RingCentralFormData
    | GHLFormData
    | CardConnectFormData
    | RaveFormData
    | TaxjarFormData
    | RaveRetailerSettings
    | NmiPaymentFormData
    | CANAFormData
    | SurveyMonkeyFormData
    | QBOTimelFormData
    | ActiveCompaignFormData
    | AffindaFormData;
}

export interface QBUpdateSettings {
  companies: Partial<QuickBooksInfo>[];
}

export interface ClickupUpdateSettings {
  companies: Partial<ClickupInfo>[];
}
export interface IntuitUpdateSettings {
  companies: Partial<IntuitInfo>[];
}

export interface GHLItemResponse {
  forms: GHLFormResponse[];
  customFields: GHLCustomFieldResponse[];
}

export interface GHLAccountResponse {
  id: string;
  name: string;
  apiKey: string;
  email: string;
}

export interface GHLFormResponse {
  id: string;
  name: string;
  apiKey: string;
}

export interface GHLCustomFieldResponse {
  id: string;
  name: string;
  fieldKey: string;
  placeholder: string;
  apiKey: string;
}

export interface EncryptionRequest {
  appId: string;
  companyId: string;
}

export interface EncryptionResponse {
  callback: string;
}

export interface RaveRetailerSettings {
  appId: string;
  accountName: string;
}

export interface CustomFieldFileResponse {
  fileName: string;
  filePath: string;
  url: string;
}

export type CustomFieldResponseType = null | string | number | CustomFieldFileResponse | CustomAddressFormData;

export interface CustomFieldResponse {
  id: string;
  name: string;
  type: string;
}

export interface ClickupInfo {
  list: string;
  team: string;
  space: string;
  linkingField: string;
  folder: string;
  defaultStatus: string;
  assignees: string[];
  userId: UserId;
}

export interface RaveCustomFieldResponse {
  id: string;
  name: string;
}
